import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with error handling for analytics
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY)
  .catch(error => {
    // Only log critical errors, ignore analytics blocking
    if (!error.message?.includes('Failed to fetch')) {
      console.error('Stripe initialization error:', error);
    }
    return null;
  });

export async function redirectToCheckout(userId: string, email: string) {
  try {
    const stripe = await stripePromise;
    
    if (!stripe) {
      throw new Error('Stripe failed to initialize');
    }

    // Get Checkout Session ID from your server
    const response = await fetch(`${window.location.origin}/api/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, email }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create checkout session');
    }

    const { sessionId } = await response.json();

    // Redirect to Checkout
    const { error } = await stripe.redirectToCheckout({ sessionId });
    
    if (error) {
      throw error;
    }
  } catch (error: any) {
    // Ignore analytics blocking errors
    if (error.message?.includes('Failed to fetch') && error.message?.includes('stripe.com/b')) {
      return;
    }
    console.error('Error redirecting to checkout:', error);
    throw error;
  }
} 